import "./social.scss";

export default function Social() {
  const data = [
    {
      id: 1,
      name: "Telegram",
      img:"https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Telegram_2019_Logo.svg/800px-Telegram_2019_Logo.svg.png",
      link:"https://t.me/SamEangTY"
    },
    {
      id: 2,
      name: "Facebook",
      img:"https://www.facebook.com/images/fb_icon_325x325.png",
      link: "https://www.facebook.com/SamerngTy", 
      featured: true,
    },
    {
      id: 3,
      name: "GitHUb",
      img: "https://upload.wikimedia.org/wikipedia/commons/c/c2/GitHub_Invertocat_Logo.svg", 
      link: "https://github.com/SamEangTy"
    },
  ];
  return (
    <div className="Social" id="social" >
      <h1>OUR SOCIAL NETWORKS!</h1>
      <div className="container">
        {data.map((d) => (
          <div className={d.featured ? "card featured" : "card"}   key={d.id}>
            <div className="top">
              <a href={d.link} target="blank" rel="noopener noreferrer" className="link">
                <img
                  className="user"
                  src={d.img}
                  alt=""
                />
              </a>
            </div> 
            <div className="bottom">
              <h3>{d.name}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
